import React from "react";
import { Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Home Pages
import Homepage from "../HomePage";


import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";

import ProductDetailPage from "../ProductDetailPage/ProductDetailPage";





import ScrollToTop from "./ScrollToTop";
import BlogPage from "../BlogPage/BlogPage";

import ContactPage from "../ContactPage/ContactPage";
import PricingPage from "../PricingPage/PricingPage";
import ErrorPage from "../ErrorPage/ErrorPage";
import TermsOfService from "../LegalPages/TermsOfService";
import PrivacyPolicy from "../LegalPages/PrivacyPolicy";
import DataDeletion from "../LegalPages/DataDeletion";

// ✅ Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* ✅ Home Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ServicePage />} />
          <Route path="/products/:slug" element={<ProductDetailPage />} />
          <Route path="/case-studies" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/data-deletion-instructions" element={<DataDeletion />} />
          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
    </div>
  );
};

export default AllRoute;
